import type { ChatMessage } from '@/types/chat'

interface UserMessageBubbleProps {
  message: ChatMessage
}

/**
 * User message bubble — right-aligned with muted background.
 */
export function UserMessageBubble({ message }: UserMessageBubbleProps) {
  return (
    <div className="flex justify-end">
      <div className="max-w-[85%] bg-muted rounded-2xl rounded-br-md px-4 py-3">
        <p className="text-foreground text-sm whitespace-pre-wrap leading-relaxed">
          {message.query}
        </p>
      </div>
    </div>
  )
}
